/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {Component, OnInit} from '@angular/core';

import {Callback, IContent, IErrorObject} from 'types/platform/universe';
import {SessionableComponent} from "../../platform/base/components/sessionable.component";
import {SessionService} from "../../platform/base/services/session.service";
import {ActivatedRoute, Router} from "@angular/router";
import {AigiaAuthService} from "../auth/aigia-auth.service";
import {Overlay} from "@angular/cdk/overlay";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {MessageDialogComponent} from "../base/components/message-dialog/message-dialog.component";
import {TranslateService} from "@ngx-translate/core";
import {IInquiryModelContent} from "../../../../types/aig/universe";
import {ContactDialogComponent} from "../contact/contact-dialog/contact-dialog.component";
import {ContactInfoDialogComponent} from "../contact/contact-info-dialog/contact-info-dialog.component";
import {InquiriesService} from "../inquiry/inquiries.service";
import {AttrPath} from "attrpath";

/**
 * todo
 */
@Component({
	selector: 'aigia-top',
	templateUrl: './top.component.html',
	styleUrls: ['./top.component.css']
})

export class TopComponent extends SessionableComponent implements OnInit {

	public username: string = "";
	public password: string = "";

	public password_visible: boolean = false;

	public params: any = {};

	/**
	 *
	 * @param sessionService
	 * @param authService
	 * @param inquiriesService
	 * @param overlay
	 * @param matDialog
	 * @param translate
	 * @param route
	 * @param router
	 *
	 */
	constructor(
		public sessionService: SessionService,
		public authService: AigiaAuthService,
		protected inquiriesService: InquiriesService,
		public overlay: Overlay,
		protected matDialog: MatDialog,
		protected route: ActivatedRoute,
		private router: Router,
		public translate: TranslateService
	) {
		super(sessionService);
	}

	/**
	 * メッセージダイアログ
	 *
	 * @returns none
	 */
	private messageDialog(message: string, callback: (result: any) => void = (result: any) => {
	}): void {
		const dialog: MatDialogRef<any> = this.matDialog.open(MessageDialogComponent, {
			width: "30%",
			minWidth: "320px",
			height: "fit-content",
			data: {content: {title: "", message: message, tag: ""}},
			disableClose: true,
		});

		dialog.afterClosed().subscribe((result: any): void => {
			callback(result);
		});
	}

	/**
	 * エラーダイアログ
	 *
	 * @returns none
	 */
	private errorDialog(error: IErrorObject, callback: (result: any) => void = (error: IErrorObject) => {}): void {
		if (error) {
			const message = this.translate.instant("ERROR.LOGIN." + error.message);
			const dialog: MatDialogRef<any> = this.matDialog.open(MessageDialogComponent, {
				width: "30%",
				minWidth: "320px",
				height: "fit-content",
				data: {content: {title: "Error.", message: message, tag: error.tag}},
				disableClose: true,
			});

			dialog.afterClosed().subscribe((result: any): void => {
				callback(result);
			});
		}
	}

	/**
	 * @returns none
	 */
	public ngOnInit(): void {
		this.getSession((error: IErrorObject, session: object): void => {
			if (!error) {
				this.username = AttrPath.traverse(session, ".username");
				this.route.queryParams.subscribe(params => {
					this.params = params;
					if (this.login) {
						this.jump();
					}
				});
			}
		})
	}

	/**
	 * @returns none
	 */
	public onAccept(): void {
		this.Progress(true);
		this.authService.login(this.username, this.password, (error: IErrorObject, result: any): void => {
			if (!error) {
				location.reload();
			} else {
				this.errorDialog(error);
			}
			this.Progress(false);
		});
	}

	/**
	 *
	 * @param width
	 */
	private widthToColumns(width: number): number {
		let result: number;
		result = width / 320;
		return result;
	}

	/**
	 * 作成
	 * @params data 初期データ
	 * @params callback コールバック
	 * @returns none なし
	 */
	public create(content: IContent, callback: Callback<any>): void {
		this.inquiriesService.post(content, (error: IErrorObject, result: any): void => {
			if (!error) {
				callback(null, result);
			} else {
				callback(error, null);
			}
		});
	}

	/**
	 * 作成
	 * @params data 初期データ
	 * @params callback コールバック
	 * @returns none なし
	 */
	public has_inquiries(callback: Callback<any>): void {
		this.inquiriesService.query( {"content.username":this.username},{sort: {}, skip: 0, limit: 0},(error: IErrorObject, result: any): void => {
			if (!error) {
				callback(null, result);
			} else {
				callback(error, null);
			}
		});
	}

	public onContact(): void {
		this.has_inquiries((error, result) => {
			if (!error) {
				if (result.length  === 0) {
					let dialogMinWidth = "320px";
					let dialogMaxWidth = "740px";
					let dialogHeight = "fit-content";

					const initalData: IInquiryModelContent = {
						id: null,
						username: this.username,
						title: "アンケート",
						contentname: "アンケート内容",
						contentdescription:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
						category: "contact",
						status: 0,
						question: "",
						answer: "",
						hascancel:false
					};

					const breakpoint = this.widthToColumns(window.innerWidth);
					if (breakpoint == 100) {
						dialogMinWidth = "100vw";
						dialogMaxWidth = "100vw";
						dialogHeight = "100vh";
					}

					const dialog: MatDialogRef<any> = this.matDialog.open(ContactDialogComponent, {
						width: "95vw",
						// minWidth: "320px",
						// maxWidth: "740px",
						// height: "fit-content",
						minWidth: dialogMinWidth, //width: 100vw;
						maxWidth: dialogMaxWidth, // height: 100vw;
						height: dialogHeight, // height: 100vh;
						panelClass: "dark-card",
						data: {content: initalData},
						disableClose: true,
					});

					dialog.beforeClosed().subscribe((result: any): void => {
						if (result) { // if not cancel then
							this.create(result, (error: IErrorObject, result: any): void => {
								if (!error) {

									const resultDialogContent: any = {title: "アンケート", message: "ありがとうございます。"};

									const info_dialog: MatDialogRef<any> = this.matDialog.open(ContactInfoDialogComponent, {
										width: "30%",
										minWidth: "320px",
										height: "fit-content",
										data: {content: resultDialogContent},
										disableClose: true,
									});

									info_dialog.afterClosed().subscribe((result: any): void => {
									});

								} else {
									this.Complete("error", null);
								}
							});
						} else {
							this.Complete("error", null);
						}
					});

					dialog.afterClosed().subscribe((result: any): void => {
						if (result) {
							this.Complete("", result);
						}
					});
				}
			} else {

			}
		});
	}

	private jump() {
		this.router.navigate(["/shotdata"]);
	}
}





